import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import "../../asset/css/custom.css";
import AppUrl from "../../RestApi/AppUrl";
import RestClient from "../../RestApi/RestClient";
import ReactHtmlParser from "react-html-parser";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

export default function Analysis() {
  const [data, setData] = useState([]);
  const [techDes, setTechDes] = useState();
  useEffect(() => {
    RestClient.GetRequest(AppUrl.HomeChart).then((result) => setData(result));
    RestClient.GetRequest(AppUrl.HomeTech).then((result) =>
      setTechDes(result[0].tech_description)
    );
  }, []);

  return (
    <>
      <Container className="text-center">
        <Fade left>
          <h1 className="title">Technology Used</h1>
        </Fade>
        <div className="bottom"></div>
        <Row>
          <Col md={12} lg={6} sm={12}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart width={100} height={100} data={data}>
                <XAxis dataKey="Technology"></XAxis>
                <Tooltip />

                <Bar dataKey="Projects" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </Col>
          <Col md={12} lg={6} sm={12}>
            <Slide right>
              <p className="text-justify description">
                {ReactHtmlParser(techDes)}
              </p>
            </Slide>
          </Col>
        </Row>
      </Container>
    </>
  );
}
